import { inject, Injectable } from '@angular/core';
import { AuthOrdoclicService } from "./auth.service";
import * as uuid from "uuid";
import { environment } from "../../../environments/environment";
import { OrdoclicLogsService } from './ordoclic-logs.service';

@Injectable({
  providedIn: 'root'
})
export class OrdoclicService {
  private ordoclicAmeliproWindow$: Promise<Window> | null = null;

  private readonly ordoclicLogsService = inject(OrdoclicLogsService);

  constructor(private authOrdoclicService: AuthOrdoclicService) { }

  getOrdoclicAmeliproWindow(): Promise<Window> {
    if (!this.ordoclicAmeliproWindow$) {
      this.ordoclicAmeliproWindow$ = this.loadIframe();
    }
    return this.ordoclicAmeliproWindow$;
  }

  private loadIframe(): Promise<Window> {

    return new Promise((resolve) => {
      this.authOrdoclicService.authenticateCode().subscribe({
        next: (response) => {
          const iframe = document.getElementById('ordoclic-amelipro-iframe') as HTMLIFrameElement;

          if (iframe) {
            iframe.src = environment.ordoclic.iframe_src + '?' +
              'tenant=' + environment.ordoclic.iframe_tenant +
              '&intent=web-messaging' +  //web-messaging / transmission / standalone
              '&auth_type=code' + // code
              '&auth_code=' + this.authOrdoclicService.getCode();

            const handleHandshake = (event: MessageEvent) => {

              if (event.data?.payload?.errorType == 'extensionNotInstalled') {
                this.showModal('flex');
              }

              if (event.source !== iframe.contentWindow) {
                return;
              }
              if (event.data.messageType !== 'status.handshake') {
                return;
              }

              resolve(iframe.contentWindow as Window);
              //this.hideModal();
              window.removeEventListener('message', handleHandshake);
            };

            window.addEventListener('message', handleHandshake);
            //this.showModal('none');
          } else {
            console.error('Iframe element not found');
          }
        },
        error: (error) => {
          console.error('Error during authentication:', error);
        }
      });

    });
  }

  private showModal(display: string): void {
    const dialog = document.getElementById('ordoclic-amelipro-dialog') as HTMLDialogElement;
    if (dialog) {
      //dialog.style.display = 'flex';
      dialog.style.display = display;
      dialog.showModal();
    } else {
      console.error('Dialog element not found');
    }
  }

  hideModal(): void {
    const dialog = document.getElementById('ordoclic-amelipro-dialog') as HTMLDialogElement;
    if (dialog) {
      dialog.style.display = 'none';
      this.ordoclicAmeliproWindow$ = null;
      dialog.close();
    } else {
      console.error('Dialog element not found');
    }
  }


  sendMessageToIframe(iframeWindow: Window, payload: Record<string, any>): Promise<any> {
    return new Promise((resolve, reject) => {
      const messageId = uuid.v4();

      const handleResponse = (event: MessageEvent) => {
        if (event.source !== iframeWindow) return;
        if (event.data.responseToMessageId !== messageId) return;

        window.removeEventListener("message", handleResponse);

        if (event.data.error) {
          console.error("Transmission error:", event.data.error);
          this.ordoclicLogsService.add("Transmission error:" + event.data.error);
          reject(event.data.error);
        } else {
          resolve(event.data.payload);
        }
      };

      window.addEventListener("message", handleResponse);

      iframeWindow.postMessage(
        {
          messageId,
          messageType: 'amelipro.transmission',
          payload,
        },
        '*'
      );

    });
  }
}
